export interface FocusQualityIndicatorState {
  lastFocusQuality?: number;
  sample: number[];
  sampleImages: any[];
  isSampling: boolean;
  bestFocusQuality?: number;
  acceptanceThreshold?: number;
  sampleCount: number;
  thresholdPercentage: number;
}

const MIN_SAMPLE_COUNT = 8;
const MAX_SAMPLE_COUNT = 50;
const SAMPLE_LENGTH = 30;
const SAMPLE_IMAGE_LENGTH = 10;
const DEFAULT_ACCEPTANCE_THRESHOLD = 95;
const DEFAULT_THRESHOLD_PERCENTAGE = 80;

export const initialState: FocusQualityIndicatorState = {
  sample: [],
  sampleImages: [],
  isSampling: true,
  sampleCount: 0,
  thresholdPercentage: DEFAULT_THRESHOLD_PERCENTAGE,
};

export enum FocusQualityIndicatorTypes {
  FEED_FOCUS_QUALITY_SAMPLE,
  SET_IS_SAMPLING,
}

export function feedFocusQualitySample(focusQuality: number, image: any) {
  return {
    type: FocusQualityIndicatorTypes.FEED_FOCUS_QUALITY_SAMPLE,
    payload: {
      focusQuality,
      image,
    },
  };
}

export function setIsSampling(isSampling: boolean) {
  return {
    type: FocusQualityIndicatorTypes.SET_IS_SAMPLING,
    payload: isSampling,
  };
}

export function reducer(
  state: FocusQualityIndicatorState,
  action: { type: FocusQualityIndicatorTypes; payload: any }
) {
  switch (action.type) {
    case FocusQualityIndicatorTypes.FEED_FOCUS_QUALITY_SAMPLE:
      return {
        ...state,
        ...addNewFocusQuality(
          action.payload.focusQuality,
          state,
          action.payload.image
        ),
      };
    case FocusQualityIndicatorTypes.SET_IS_SAMPLING:
      return {
        ...state,
        isSampling: action.payload,
      };
    default:
      return state;
  }
}

function addNewFocusQuality(
  focusQuality: number,
  state: FocusQualityIndicatorState,
  image: any
) {
  const { sample, bestFocusQuality } = state;
  const newSample = [...sample, focusQuality];
  if (newSample.length > SAMPLE_LENGTH) {
    newSample.shift();
  }
  const newBestFocusQuality =
    bestFocusQuality === undefined || focusQuality > bestFocusQuality
      ? focusQuality
      : bestFocusQuality;

  const thresholdFactor = state.thresholdPercentage / 100;
  const newAcceptanceThreshold = newBestFocusQuality * thresholdFactor;
  const newSampleCount = state.sampleCount + 1;

  const newImageSample = [...state.sampleImages, image];
  if (newImageSample.length > SAMPLE_IMAGE_LENGTH) {
    newImageSample.shift();
  }
  return {
    lastFocusQuality: focusQuality,
    sample: newSample,
    sampleImages: newImageSample,
    sampleCount: newSampleCount,
    isSampling: newSampleCount < MAX_SAMPLE_COUNT,
    bestFocusQuality: newBestFocusQuality,
    acceptanceThreshold:
      newSampleCount >= MIN_SAMPLE_COUNT
        ? newAcceptanceThreshold > DEFAULT_ACCEPTANCE_THRESHOLD
          ? newAcceptanceThreshold
          : DEFAULT_ACCEPTANCE_THRESHOLD
        : undefined,
  };
}
